import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import SessionTitleRow from "./SessionTitleRow";
import UpcomingSessionDetailsCard from "./UpcomingSessionDetailsCard";
import ScreenerCard from "./ScreenerCard";
import AboutUserCard from "./AboutUserCard";

// Api Calls



function UpcomingSessionPage(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, sessionId } = useParams()




    return (
        <>
            <SubHeader title={"Upcoming Session"} backText="Back to Upcoming Sessions" navigateBack={() => navigate("/missions/" + missionId + "/upcomingsessions/")} />
            <MissionPageContainer>
                <SessionTitleRow session={props.session} timezone={props.timezone} />
                <UpcomingSessionDetailsCard session={props.session} timezone={props.timezone} />
                {props.hasScreener ? <ScreenerCard mission_user_list_id={props.session.mission_user_list_id} /> : null}
                <AboutUserCard mission_user_list_id={props.session.mission_user_list_id} />
            </MissionPageContainer>
        </>

    )

}

export default UpcomingSessionPage;